import React from "react";
import { PanelFrame } from "../ui/PanelFrame";

export function HomeContent() {
  return (
    <PanelFrame>
      <div
        style={{
          fontSize: 18,
          letterSpacing: "0.12em",
          color: "#8fa8e8",
          marginBottom: 8,
        }}
      >
        WILLKOMMEN BEI LEGENDSTOOLS
      </div>
      <div
        style={{
          marginTop: 6,
          padding: 10,
          borderRadius: 10,
          border: "1px solid rgba(255,255,255,0.08)",
          background:
            "radial-gradient(circle at top, rgba(255,255,255,0.02), rgba(2,6,14,0.98))",
          fontSize: 13,
          lineHeight: 1.5,
        }}
      >
        <p>
          Zentrale Oberfläche für Analyse- und Mapping-Tools rund um Travian
          Legends. Die <strong>Legends Map</strong> ist bereits live mit deiner
          eigenen Datenbank verbunden.
        </p>
        <p>
          Weitere Module – Statistiken, Inaktivitäts-Scanner,
          Timing-/Abfang-Tools – docken hier Schritt für Schritt an.
          Layout und Bedienlogik bleiben konsistent.
        </p>
        <a
          href="/map/"
          style={{
            display: "inline-flex",
            marginTop: 10,
            padding: "8px 14px",
            borderRadius: 8,
            border: "1px solid #ff8800",
            color: "#ff8800",
            fontSize: 13,
            textDecoration: "none",
            alignItems: "center",
            gap: 6,
            transition: "all 0.15s ease-out",
          }}
        >
          ► LEGENDS MAP STARTEN
        </a>
      </div>
    </PanelFrame>
  );
}
